import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgBucks = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18.375 26.25a9.625 9.625 0 1 1 0-19.25 9.625 9.625 0 0 1 0 19.25Zm0-1.75a7.876 7.876 0 1 0 0-15.751 7.876 7.876 0 0 0 0 15.751ZM17.106 5.32c-.676.075-1.343.211-1.995.406a7.876 7.876 0 1 0-7.887 13.151c.135.674.329 1.325.577 1.95A9.629 9.629 0 0 1 9.625 1.75a9.608 9.608 0 0 1 7.481 3.57Zm4.095 12.997c0 1.19-.852 2.135-2.1 2.333v1.038a.185.185 0 0 1-.187.187h-.78a.186.186 0 0 1-.185-.113.188.188 0 0 1-.015-.074v-1.026a3.71 3.71 0 0 1-2.146-1.05.198.198 0 0 1 0-.234l.583-.805a.187.187 0 0 1 .14-.07c.058 0 .117.012.14.06.012 0 .84.792 1.867.792.583 0 1.2-.315 1.2-.968 0-.56-.7-.84-1.48-1.167-1.05-.408-2.37-.933-2.37-2.403 0-1.085.84-1.972 2.066-2.205v-1.05c0-.117.094-.187.2-.187h.78c.117 0 .187.082.187.187v1.026c1.19.14 1.832.782 1.855.805a.174.174 0 0 1 .023.222l-.466.852a.176.176 0 0 1-.14.093.201.201 0 0 1-.164-.035s-.71-.63-1.586-.63c-.747 0-1.26.362-1.26.898 0 .62.71.9 1.54 1.214 1.085.42 2.298.898 2.298 2.31Z" />
  </svg>
);
export default SvgBucks;
